import GenericNavigation from './GenericNavigation';

function Navigation({ parentToChild, modeChange }: any) {
  const navItems: [string, string][] = [
    ["About Us", 'aboutUs'],
    ["Services", 'services'],
    ['Expertise', 'expertise'],
    ['Milestones', 'history'],
    ['Achievements', 'projects'],
    ['Contact Us', 'contact']
  ];
  const servicesOptions = [
    "iOS app development",
    "Android app development",
    "Mobile app development",
    "AI-Centric Development"
  ];
  const mode = parentToChild?.mode || 'light';
  return (
    <GenericNavigation navItems={navItems} servicesOptions={servicesOptions} mode={mode} modeChange={modeChange} />
  );
}

export default Navigation;